export const enum PayStationPaymentState {
    QUOTED = 'QUOTED',
    PAID = 'PAID',
    ABORTED = 'ABORTED',
}

export const enum PayStationPaymentMethod {
    CASH = 'CASH',
    CASHLESS = 'CASHLESS',
}
